// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1ADgW","list":"BalanceDue_list__GbupV","listRow":"BalanceDue_listRow__1drtN","total":"BalanceDue_total__Qm9j_"};